const confirmEmail = function() {
  if ($('#text_confirm').length == 0) return

  if ($('#email').val() == $('#text_confirm').val() && $('#email').val().trim() != '') {
    $('#confirmEmailMessage').addClass('d-none')
    $('.submitEmail').removeAttr('disabled')
  } else {
    $('.submitEmail').attr('disabled', 'disabled')

    if ($('#text_confirm').val().trim() != '') {
      $('#confirmEmailMessage').addClass('d-none')
      $('#emailMismatchMessage').removeClass('d-none')
    } else {
      $('#confirmEmailMessage').removeClass('d-none')
      $('#emailMismatchMessage').addClass('d-none')
    }
  }
}

$(document).on('change keyup', '#email, #text_confirm', confirmEmail)
$(confirmEmail)
